// extracted by mini-css-extract-plugin
export var playBtn = "video-module--playBtn--16ZFR";
export var playBtnWrapper = "video-module--playBtnWrapper--7C-iC";
export var videoWrapper = "video-module--videoWrapper--f+ZX5";